// extracted by mini-css-extract-plugin
module.exports = {"loader":"generatePasses_loader__29UYw","spin":"generatePasses_spin__3JnaR","container":"generatePasses_container__f_eUs","box":"generatePasses_box__tZJxc"};